import { getQrCodeList, manageQrCode } from './api'
import { qrCodeSlice } from './reducer'

const { selectQrCode, selectAllQrCode, deSelectAllQrCode, resetError } =
  qrCodeSlice.actions

export {
  getQrCodeList,
  selectQrCode,
  selectAllQrCode,
  deSelectAllQrCode,
  manageQrCode,
  resetError
}
